import { useMemo } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../store/store"
import { createPermissionsFromApi, type Scope } from "../../utils/permissions"

export const usePermissions = () => {
    const userPermissions = useSelector((state: RootState) => state.sessionData.data?.permissions)
    const apiPermissions = useSelector((state: RootState) => state.sessionData.data?.permissions2)

    const permissionsInstance = useMemo(() => {
        if (!apiPermissions) return null
        try {
            return createPermissionsFromApi(apiPermissions)
        } catch {
            return null
        }
    }, [apiPermissions])

    function hasPermission(moduleName: string, permission: string | string[]) {
        const permissions = Array.isArray(permission) ? permission : [permission];
        if (!userPermissions?.[moduleName] || !Array.isArray(userPermissions[moduleName]) || userPermissions[moduleName].length === 0) return false;
        return permissions.some(permission => userPermissions[moduleName].includes(permission));
    }

    function hasPermission2(permissionPath: string, requiredScope: Scope): boolean {
        if (!permissionsInstance) return false
        try {
            return permissionsInstance.has(permissionPath, requiredScope)
        } catch {
            return false
        }
    }

    return { hasPermission, hasPermission2 }
}
